import * as React from 'react';
import type { SVGProps } from 'react';
const SvgQuestionMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={12}
    fill="none"
    viewBox="0 0 8 12"
    {...props}
  >
    <path
      fill="#7F7F7F"
      d="M5.6 3.117q0-.634-.45-1.042T4 1.667q-.433 0-.792.191a1.9 1.9 0 0 0-.625.542 1 1 0 0 1-.591.4.9.9 0 0 1-.675-.1q-.334-.2-.4-.508-.068-.309.166-.642A3.36 3.36 0 0 1 2.342.408 3.5 3.5 0 0 1 4 0q1.483 0 2.417.858.933.86.933 2.209 0 .699-.308 1.275-.309.575-1.109 1.325-.533.483-.716.783-.184.3-.25.683a1.1 1.1 0 0 1-.325.625.86.86 0 0 1-.609.242.85.85 0 0 1-.616-.242.77.77 0 0 1-.25-.575q0-.616.291-1.158.292-.542.925-1.075.717-.633.967-1 .25-.366.25-.833M4 11.6q-.5 0-.85-.35a1.16 1.16 0 0 1-.35-.85q0-.5.35-.85T4 9.2t.85.35.35.85-.35.85-.85.35"
    />
  </svg>
);
export default SvgQuestionMark;
